// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"16d74ebe","455":"1c178dc6"}[chunkId] + ".chunk.js";
};